import { render, staticRenderFns } from "./liquidator-type.vue?vue&type=template&id=37bdf0f3&"
import script from "./liquidator-type.vue?vue&type=script&lang=js&"
export * from "./liquidator-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports